import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Navbar, Footer } from "@/pages/Home";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="pt-40 pb-32 max-w-xl mx-auto px-4 text-center">
        <XCircle className="w-14 h-14 text-slate-300 mx-auto" />
        <h1 data-testid="cancel-heading" className="font-display uppercase text-4xl font-bold text-[#0A192F] mt-6">Payment cancelled</h1>
        <p className="text-slate-500 mt-4 text-sm leading-relaxed">
          No charge was made. Your chosen time slot may still be held for a short while — head back to pick another time or try again.
        </p>
        <Link
          to="/book"
          data-testid="cancel-retry-btn"
          className="inline-flex items-center gap-2 mt-10 rounded-full bg-[#0A192F] text-white font-bold px-8 py-4 hover:bg-sky-800 transition-colors duration-200"
        >
          Back to Booking
        </Link>
      </div>
      <Footer />
    </div>
  );
}
